/* eslint-disable prefer-const */
/* eslint-disable no-return-assign */
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory, useParams, useLocation } from 'react-router-dom'
import { FacebookShareButton } from 'react-share'
import SignUpPopup from '../../components/SignUpPopup'
import {
  Grid,
  Typography,
  Modal,
  Button as StyledButton,
} from '@material-ui/core/'
import { LinearDeterminate, Notification, Button } from 'components/UI/'
import moment from 'moment'
import api from '../../api/stoty'
import apiChat from '../../api/chat'
import apiGoogle from '../../api/auth'
import { setChatRequesStoryId, setNotRegisterStory, googleId, signInAction } from '../../modules/session/actions'
import { setScroll } from '../../modules/scroll/actions'
import GoToMeetMessage from './components/index.js'
import { СameraIcon } from '../../assetss/img/index.js'
import arrowLeft from '../../assetss/img/arrowLeft.svg'
import ShareIcon from '../../assetss/img/share.svg'
import userIcon from '../../assetss/img/userIcon.svg'
import bookmark from '../../assetss/img/bookmark.svg'
import userMobile from '../../assetss/img/userMobile.svg'
import shareMobile from '../../assetss/img/shareMobile.svg'
import bookmarkMobile from '../../assetss/img/bookmarkMobile.svg'
import userBlack from '../../assetss/img/userBlack.svg'
import shareBlack from '../../assetss/img/shareBlack.svg'
import bookmarkBlack from '../../assetss/img/bookmarkBlack.svg'
import arrowBlack from '../../assetss/img/arrowBlack.svg'
import checkedUserStory from '../../assetss/img/checkedUserStory.svg'
import nature from '../../assetss/img/nature.jpeg'
import c from 'classnames'
import './index.scss'

const AcceptKeepCaht = ({ open, setOpen, text, title }) => (
  <Modal
    open={open}
    onClose={setOpen}
  >
    <div className='accepStoryToChat'>
      <div className='boxKeepModal'>
        <div className='textKeep'>{title}</div>
        {text && (
          <Grid className='boxerrorStoryAdd'>
            <img className='ifoStoryIcon' src={checkedUserStory} />
            <div className='textDesc'>{text}</div>
          </Grid>
        )}
        <Button
          className='keepBtnChat'
          onClick={setOpen}
        >
          Ok
        </Button>
      </div>
    </div>
  </Modal>
)

const Story = () => {
  const [dataStory, setDataStory] = useState()
  const [erroMessage, setErrorMessage] = useState('')
  const [type, setType] = useState('')
  const [open, setOpen] = useState(false)
  const [openNotification, setOpenNotification] = useState(false)
  const [loading, setLoading] = useState(true)
  const [successContent, setSuccessContent] = useState(false)
  const { session, scroll } = useSelector(state => state)
  const { storyId, newStory } = useParams('')
  const history = useHistory()
  const locations = useLocation()
  const [defaultValue, setDefaultValue] = useState('')
  const [value, setValue] = useState()
  const { user, chatStoryId, notRegisterStory } = useSelector(({ session }) => session)
  const dispatch = useDispatch()
  const chatClass = document.querySelector('.layout')
  const [addeStoryText, setAddedStoryText] = useState('')
  const [addeStoryTitle, setAddedStoryTitle] = useState('')

  const onSignUp = () => {
    apiGoogle.loginGuoogle().then(e => {
      dispatch(googleId(e?.data?.url))
      if (e?.data?.url) {
        window.location.href = e?.data?.url
        dispatch(signInAction(e?.data))
      }
    })
  }

  const onClose = () => {
    setOpen(false)
    setSuccessContent(false)
  }
  const onContent = () => setSuccessContent(prev => !prev)

  const createBookmark = () => {
    if (session?.user?.user?.uuid) {
      api.createBookmark({ accessKey: session?.user?.accessKey, storyUuid: dataStory?.uuid })
        .then(data => {
          if (data?.data?.status === 'ok') {
            setType('success')
            setErrorMessage('The story has been successfully added to your bookmarks!')
            setOpenNotification(true)
          } else {
            setOpen(false)
            setErrorMessage(data?.data?.error?.message)
            setOpenNotification(true)
            setType('error')
          }
        })
    } else {
      dispatch(setNotRegisterStory({
        type: 'bookmark',
        storyId: dataStory?.uuid,
      }))
      onSignUp()
    }
  }

  const createReport = () => {
    if (session?.user?.user?.uuid) {
      api.createReport({ accessKey: session?.user?.accessKey, storyUuid: dataStory?.uuid })
        .then(data => {
          if (data?.data?.status === 'ok') {
            setType('success')
            setErrorMessage('Thanks for letting us know!')
            setOpenNotification(true)
          } else {
            setOpen(false)
            setErrorMessage(data?.data?.error?.message)
            setOpenNotification(true)
            setType('error')
          }
        })
    } else {
      dispatch(setNotRegisterStory({
        type: 'report',
        storyId: dataStory?.uuid,
      }))
      onSignUp()
    }
  }

  const createLike = () => {
    if (session?.user?.user?.uuid) {
      api.createLike({ accessKey: session?.user?.accessKey, storyUuid: dataStory?.uuid })
        .then(data => {
          if (data?.data?.status === 'ok') {
            setType('success')
            setErrorMessage('Thanks for your support! The person who wrote the story will receive a notification — think of it as a virtual hug that you gave.')
            setOpenNotification(true)
          }
        })
    } else {
      api.createLikeAnonymous({ storyUuid: dataStory?.uuid })
        .then(({ data }) => {
          if (data?.status === 'ok') {
            setType('success')
            setErrorMessage('Thanks for your support! The person who wrote the story will receive a notification — think of it as a virtual hug that you gave.')
            setOpenNotification(true)
          }
        })
    }
  }

  const tellMeHandler = () => {
    apiChat.createChat(dataStory?.author?.uuid, session?.user?.accessKey, value, dataStory?.uuid)
      .then(data => {
        if (data?.data?.status === 'ok') {
          onContent()
        } else {
          setOpen(false)
          setErrorMessage(data?.data?.error?.message)
          setOpenNotification(true)
          setType('error')
        }
      })
  }

  useEffect(() => {
    if (storyId) {
      api.getStorie(storyId)
        .then(res => {
          if (res?.data?.status === 'ok') {
            setDataStory(res?.data?.story)
            setLoading(false)
          }
        })
    }
  }, [storyId])

  useEffect(() => {
    if (dataStory?.author?.name) {
      setValue(defaultValue)
      setDefaultValue(`Hi ${dataStory?.author?.name}! I want to hear your story.`)
    }
  }, [dataStory?.author?.name])

  useEffect(() => {
    if (defaultValue) {
      setValue(defaultValue)
    }
  }, [defaultValue])

  const addedStory = () => {
    if (user?.accessKey) {
      apiChat?.addedStoryChat(session?.user?.accessKey, dataStory?.uuid, dataStory?.author?.uuid)
        .then(res => {
          if (res?.data?.error?.message === 'Such story is already in this chat') {
            setAddedStoryTitle(`You've already asked ${dataStory?.author?.name} to tell this story!`)
          } else if (res?.data?.error?.message === 'Such chat is not exist') {
            setOpen(true)
          } else if (res?.data?.status === 'ok') {
            setAddedStoryText('The story will be added to your chat and you\'ll be able to schedule a meeting to discuss it.')
            setAddedStoryTitle(`You're already chatting with ${dataStory?.author?.name} the author of this story.`)
          } else if (res?.data?.error?.message === 'Chat with this user was declined') {
            setOpen(true)
          } else {
            setErrorMessage(res?.data?.error?.message)
            setOpenNotification(true)
            setType('error')
          }
        })
    } else {
      dispatch(setChatRequesStoryId(dataStory?.uuid))
      onSignUp()
    }
  }

  useEffect(() => {
    if (chatStoryId) {
      if (user?.accessKey) {
        setOpen(true)
        setTimeout(() => {
          dispatch(setChatRequesStoryId(''))
        }, 1000)
      }
    }
  }, [chatStoryId, user?.accessKey])

  useEffect(() => {
    if (notRegisterStory?.type === 'bookmark') {
      if (user?.accessKey) {
        if (dataStory?.uuid) {
          createReport()
          dispatch(setNotRegisterStory({
            type: '',
            storyId: '',
          }))
        }
      }
    } else if (notRegisterStory?.type === 'report') {
      if (user?.accessKey) {
        if (dataStory?.uuid) {
          createReport()
          dispatch(setNotRegisterStory({
            type: '',
            storyId: '',
          }))
        }
      }
    }
  }, [notRegisterStory?.type, user?.accessKey, dataStory?.uuid])

  useEffect(() => {
    dispatch(setScroll({ scroll: 0 }))
    chatClass?.scrollTo(0, 0)
  }, [])

  return (
    <Grid className='wrapperUserStory' container direction='column' alignItems='center' wrap='nowrap'>
      <SignUpPopup isAuth={user?.user?.uuid} onSignUp={onSignUp} />

      <AcceptKeepCaht
        open={addeStoryTitle}
        text={addeStoryText}
        title={addeStoryTitle}
        setOpen={() => {
          setAddedStoryText('')
          setAddedStoryTitle('')
        }}
      />
      <Notification text={erroMessage} open={openNotification} type={type} onClose={setOpenNotification} />
      {loading && <LinearDeterminate />}
      <GoToMeetMessage
        open={open}
        onClose={onClose}
        content={successContent}
        tellMeHandler={tellMeHandler}
        name={dataStory?.author?.name}
        defaultValue={defaultValue}
        onChange={e => setValue(e?.target?.value)}
      />
      <Grid
        className='headerBackground'
        justify='center'
        container
      >
        <img src={dataStory?.image?.src || nature} className='imgUserStory' />
        <Grid className='backContainer' container direction='column' justify='space-between'>
          <Grid className={c('headerIconMobile', scroll?.scroll?.scroll && 'scrollBackHeader')} container justify='space-between' alignItems='center'>
            <Grid
              className='clickBox'
              container
              alignItems='center'
              onClick={() => {
                if (newStory) {
                  history.push('/')
                } else {
                  history?.goBack()
                }
              }}
            >
              <img className='arrowBackWidth' src={scroll?.scroll?.scroll ? arrowBlack : arrowLeft} alt='arrowLeft' />
              <Typography className={c('textBack', scroll?.scroll?.scroll && 'textBackScroll')}>Back</Typography>
            </Grid>
            {dataStory?.author?.uuid !== user?.user?.uuid && (
              <Grid className='mobileIconBtn' container>
                <img onClick={createLike} className='iconHover' src={scroll?.scroll?.scroll ? userBlack : userMobile} alt='userMobile' />
                <FacebookShareButton className='btnItemBox' url={`test.tellme.place/${locations?.pathname}`} quote={dataStory?.text} hashtag={dataStory?.hashtags?.[0]}>
                  <img className='iconHover' src={scroll?.scroll?.scroll ? shareBlack : shareMobile} alt='shareMobile' />
                </FacebookShareButton>
                <img onClick={createBookmark} className='iconHover' src={scroll?.scroll?.scroll ? bookmarkBlack : bookmarkMobile} alt='bookmarkMobile' />
              </Grid>
            )}
          </Grid>
          <Grid className='titleMobile' container justify='center'>
            <Typography className='titileStory' align='center'>'{dataStory?.title}'</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid container className='storyContent' wrap='nowrap'>
        {dataStory?.author?.uuid !== user?.user?.uuid && (
          <Grid className='storyBtnBox' container direction='column' alignItems='center'>
            <StyledButton
              className='tellMeButton'
              // startIcon={<СameraIcon />}
              variant="outlined"
              onClick={addedStory}
            >
              Request meeting
            </StyledButton>
            <FacebookShareButton className='btnItemBox' url={`test.tellme.place/${locations?.pathname}`} quote={dataStory?.text} hashtag={dataStory?.hashtags?.[0]}>
              <img className='storyBtnIcon' src={ShareIcon} alt='ShareIcon' />
              <Typography>Share story</Typography>
            </FacebookShareButton>
            <Grid className='btnItemBox' onClick={createLike}>
              <img className='storyBtnIcon' src={userIcon} alt='userIcon' />
              <Typography>I am with you</Typography>
            </Grid>
            <Grid className='btnItemBox' onClick={createBookmark}>
              <img className='storyBtnIcon' src={bookmark} alt='bookmark' />
              <Typography>Bookmark</Typography>
            </Grid>
          </Grid>
        )}
        {dataStory?.author?.uuid === user?.user?.uuid ? (
          <Grid className='storyTextBoxAuthor' container direction='column' justify='space-between' alignItems='center'>
            <pre className='storyText'>{dataStory?.text}</pre>
            <Typography className='datePosted' align='right'>
              Posted on {moment(+dataStory?.createdAt).format('MMMM D, h:mm A')} {+dataStory?.type === 0 ? 'by someone who need help' : 'by someone who cares'} {dataStory?.author?.town && `from ${dataStory?.author?.town}`}
            </Typography>
          </Grid>
        ) : (
          <Grid className='storyTextBox' container direction='column' justify='space-between'>
            <pre className='storyText'>{dataStory?.text}</pre>
            <Typography className='datePosted' align='right'>Posted on {moment(+dataStory?.createdAt).format('MMMM D, h:mm A')} {+dataStory?.type === 0 ? 'by someone who need help' : 'by someone who cares'} {dataStory?.author?.town && `from ${dataStory?.author?.town}`}</Typography>
          </Grid>
        )}
      </Grid>

      {dataStory?.author?.uuid !== user?.user?.uuid && (
        <StyledButton
          className='tellMeButtonMobile'
          // startIcon={<СameraIcon />}
          variant="outlined"
          onClick={addedStory}
        >
          Request meeting
        </StyledButton>
      )}

      {dataStory?.author?.uuid !== user?.user?.uuid && (
        <Grid className='reportContainer' container justify='center'>
          <StyledButton
            className='moreStoryButton'
            variant="outlined"
            onClick={() => history.push('/')}
          >
            Get more stories
          </StyledButton>
          <Typography className='reportText' onClick={createReport}>Report offensive content</Typography>
        </Grid>
      )}
    </Grid>
  )
}

export default Story
